export default __webpack_public_path__ + "static/media/guia-gsuite.759ab4e8.pdf";